// appviews.js
// import { Platform } from "react-native";

// Public Views
import Login from "../Views/Login";
import Logout from "../Views/Logout";
// import ResetPassword from "../Views/ResetPassword";
// import ResetPasswordConfirm from "../Views/ResetPasswordConfirm";
// import Register from "../Views/Register";
// import RegisterCode from "../Views/RegisterCode";


// Main menu pages
import Subscribers from "components/Views/Subscribers/SubscribersList";
import Organization from "components/Views/Subscribers/Organization/OrganizationDetails";
import Profile from "components/Views/Profile";

// // Inactive Account
// import Inactive from "../Views/Inactive";
// // Downtime / Scheduled Maintenance
// import Offline from "../Views/Offline";
// import Downtime from "../Views/Downtime";

//  /!\ Lower-case key names! /!\  \\
const appviews = {

  // Public pages
  // ⬇ LOGIN MUST BE FIRST BY DEFAULT
  login: {
    title: "Log In",
    view: Login,
    noheader: true,
    private: false,
    superadmin: false,
    menu: "",
  },

  // Main Menu Items
  // ⬇ LOGIN MUST BE FIRST BY DESIGN
  subscribers: {
    title: "Subscribers",
    view: Subscribers,
    private: true,
    superadmin: false,
    menu: "main",
    icon: "list",
  },
  organization: {
    title: "Organization",
    view: Organization,
    private: true,
    superadmin: false,
    menu: null,
    icon: null,
  },

  profile: {
    title: "Profile",
    view: Profile,
    private: true,
    superadmin: false,
    menu: "main",
    icon: "user",
  },

  logout: {
    title: "Log out",
    function: Logout,  // view: Logout,
    private: true,
    superadmin: false,
    menu: "main",
    icon: "log-out",
  },

  // reset: {
  //   title: "Reset Password",
  //   view: ResetPassword,
  //   noheader: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },
  // resetcode: {
  //   title: "Reset Password Confirmation",
  //   view: ResetPasswordConfirm,
  //   noheader: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },
  // inactive: {
  //   title: "Inactive Account",
  //   view: Inactive,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },
  // downtime: {
  //   title: "Scheduled Maintenance",
  //   view: Downtime,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },
  // offline: {
  //   title: "Offline",
  //   view: Offline,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },


  // register: {
  //   title: "Register Email",
  //   view: Register,
  //   noheader: true,
  //   external: true,
  //   superadmin: false,
  //   menu: "",
  // },

  // registercode: {
  //   title: "Complete Registration",
  //   view: RegisterCode,
  //   noheader: true,
  //   external: true,
  //   superadmin: false,
  //   menu: "",
  // },

};

appviews.keys = Object.keys(appviews);
appviews.publicKeys = Object.keys(appviews).filter(key=>(!appviews[key].private));
appviews.mainMenuKeys = Object.keys(appviews).filter(key=>(appviews[key].menu==="main"));
// appviews.externalKeys = Object.keys(appviews).filter(key => !!appviews[key].external && !!appviews[key].menu!=="admin");

export default appviews;
